export enum ThankYouPageContentType {
  FINISHED_PRACTICE_STAGE = 'FINISHED_PRACTICE_STAGE',
  NEXT_PRACTICE_STAGE = 'NEXT_PRACTICE_STAGE',
  FINISHED_STAGE_WITHOUT_REPORT = 'FINISHED_STAGE_WITHOUT_REPORT',
  NEXT_TEST_CONTENT = 'NEXT_TEST_CONTENT',
  REPORT_IS_READY_CONTENT = 'REPORT_IS_READY_CONTENT',
}
